import { render, staticRenderFns } from "./select_reg_type.vue?vue&type=template&id=a79bb13e&scoped=true&"
import script from "./select_reg_type.vue?vue&type=script&lang=js&"
export * from "./select_reg_type.vue?vue&type=script&lang=js&"
import style0 from "./select_reg_type.vue?vue&type=style&index=0&id=a79bb13e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79bb13e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a79bb13e', component.options)
    } else {
      api.reload('a79bb13e', component.options)
    }
    module.hot.accept("./select_reg_type.vue?vue&type=template&id=a79bb13e&scoped=true&", function () {
      api.rerender('a79bb13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/seafarer_reg/select_reg_type.vue"
export default component.exports